import React from "react";
import Header from "../../components/header/Header.component";
import Footer from "../../components/footer/Footer.component";

import "../top-airlines/top-airlines.style.css";
import BannerSearchForm from "../../components/flight-search-form/BannerSearchForm.component";
import FlightSearchForm from "../../components/flight-search-form/FlightSearchForm.component";

export const NewYork = () => {
  return (
    <>
      <div className="home-banner">
        <div className="cm-page-center">
          <div className="search-banner">
            <h1>Let AirFareHQ bring your dream vacation to new heights.</h1>
            <FlightSearchForm />
          </div>
        </div>
      </div>
      <div className="cm-section cm-page-center">
        {/* <BannerSearchForm depVal={data} urlVal={dataToSend} /> */}
        <div className="ryan-air">
          <div className="ryanair-title">
            <h1>New York</h1>
          </div>
          <div className="ryanair-content">
            <p>
              Looking for the finest return ticket to New York or a cheap
              last-minute deal? Choose from three nearby Airports when booking
              flights to New York: Newark Liberty International Airport (EWR),
              John F. Kennedy International Airport, formerly known as JFK, and
              LaGuardia Airport (LGA).
            </p>
            <p>
              Nearby New Jersey's Newark Airport, which is about 18 miles
              Southwest of Manhattan, has three terminals with various shopping
              and dining options and multiple charging stations. LaGuardia is
              located close to NYC's east coast. There are cafes, restaurants,
              and concession stands in each of the four terminals. As for JFK
              airport is located in Queens, 18 miles southeast of New York City,
              providing cafes, bars, restaurants, and retail shops with eight
              terminals. Furthermore, All three of these New York airports also
              offer taxi, limousine, and shuttle services.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};
